<template>
  <div style="justify-content: center; display: flex;">
    <div v-if="lesson" class="card border-0 bg-gradient-secondary" style="width: 500px;">
      <form class="card-body py-5">
        <!-- Step 1: Coupon + Payment Summary -->
        <div v-if="currentStep === 1">
          <h4 class="display-4 mb-0 text-primary text-uppercase">Төлбөрийн мэдээлэл</h4>
          <label> Гүйлгээний утга</label>
          <h2 class="m-2">{{ lesson.title }}</h2>
          <label> Төлбөр</label>
          <h3 class="m-2">{{ formattedPrice }}₮</h3>
          <label>Купон код (хэрвээ байгаа бол)</label>
          <input v-model="couponCode" class="form-control" type="text" placeholder="Купон код оруулах" />
          <button class="btn btn-sm btn-outline-primary mt-2" @click.prevent="checkCoupon">Купон шалгах</button>
          <h3 class="mb-3">Нийт: {{ finalPrice }}₮</h3>
          <div v-if="couponMessage" class="mt-2 text-info">{{ couponMessage }}</div>
          <div>
            <base-button @click="handleView()">Буцах</base-button>
            <base-button @click="goToStep(2)">Үргэлжлүүлэх</base-button>
          </div>
        </div>

        <!-- Step 2: Choose payment method -->
        <div v-if="currentStep === 2">
          <h4 class="display-4 mb-0 text-primary text-uppercase">Төлбөрийн сонголт</h4>
          <div class="payment-grid mt-4">
            <div style="width: max-content;" :class="['payment-method', { selected: selectedMethod === method.id }]"
              v-for="method in paymentMethods" :key="method.id" @click="selectMethod(method.id)">
              <div class="method-icon">
                <img :src="method.icon" :alt="method.name" />
              </div>
            </div>
          </div>
          <base-button @click="goToStep(1)">Буцах</base-button>
          <base-button @click="processPayment" :disabled="!selectedMethod">Төлбөр төлөх</base-button>
        </div>
      </form>
    </div>
    <div v-else>Loading...</div>

    <PaymentModal :show="showPaymentModal" :qr-image="qpayImage" :invoiceId="transaction_id" :urls="paymentUrls" @close="closePaymentModal"
      @payment-success="handlePaymentSuccess" />
  </div>
</template>

<script>
import PaymentModal from './../components/lesson/PaymentModal.vue';
import axios from 'axios';

export default {
  name: "PaymentPage",
  components: { PaymentModal },
  data() {
    return {
      lesson: null,
      selectedMethod: '',
      showPaymentModal: false,
      endTime: null,
      qpayImage: '',
      couponCode: '',
      discountPercent: 0,
      couponMessage: '',
      transaction_id: '',
      currentStep: 1,
      paymentUrls: [],
      paymentMethods: [
        { id: 'qpay', name: 'QPay', icon: require('@/assets/qpay.png') }
      ]
    };
  },
  computed: {
    finalPrice() {
      if (!this.lesson) return 0;
      const discount = (this.lesson.price * this.discountPercent) / 100;
      return Math.max(this.lesson.price - discount, 0);
    },
    formattedPrice() {
      return new Intl.NumberFormat("mn-MN").format(this.lesson.price || 0);
    },
  },
  created() {
    this.fetchLesson();
  },
  mounted() {
    // Warn user if they refresh or close the window
    window.addEventListener('beforeunload', this.beforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeUnload);
  },
  methods: {
    async fetchLesson() {
      const lessonId = this.$route.params.id;
      if (!lessonId) return;
      try {
        const response = await axios.get(`/lesson/${lessonId}`);
        this.lesson = response.data.lesson;
      } catch (error) {
        console.error('Failed to fetch lesson:', error);
      }
    },
    handleView() {
      const lessonId = this.$route.params.id;
      this.$router.push(`/lesson/view/${lessonId}`);
    },
    goToStep(step) {
      this.currentStep = step;
    },
    selectMethod(methodId) {
      this.selectedMethod = methodId;
    },
    async checkCoupon() {
      this.couponMessage = '';
      this.discountPercent = 0;
      if (!this.couponCode) {
        this.couponMessage = 'Купон код оруулна уу.';
        return;
      }
      try {
        const response = await axios.post('/coupon/check', {
          code: this.couponCode,
          lesson_id: '1'
        });
        const data = response.data;
        this.discountPercent = data.percent;
        this.couponMessage = `${data.percent}% хямдралтай боллоо!`;
      } catch (error) {
        this.discountPercent = 0;
        this.couponMessage = error.response.data.detail || 'Купон шалгах үед алдаа гарлаа.';
      }
    },
    async processPayment() {
      if (!this.selectedMethod || !this.lesson) return;
      try {
        if (this.qpayImage === '') {
          const response = await axios.put(`/lesson/${this.lesson.id}/subscribe`, {
            responseType: 'blob',
            coupon_code: this.couponCode
          });
          console.log('response.data', response.data);
          this.qpayImage = response.data.qr_image;
          this.transaction_id = response.data.transaction_id;
          this.paymentUrls = response.data.urls;
        }
        this.showPaymentModal = true;
      } catch (error) {
        console.error('Payment failed:', error);
      }
    },
    handlePaymentSuccess() {
      // this.showPaymentModal = false;
      // this.$router.push('/payment/success');
    },
    closePaymentModal() {
      this.showPaymentModal = false;
    },
    // Handle browser unload (refresh/close)
    // beforeUnload(event) {
    //   event.preventDefault();
    //   event.returnValue = '';
    // }
  },
  // Vue Router navigation guard to warn when navigating away
  // beforeRouteLeave(to, from, next) {
  //   if (transaction_id) {
  //     const answer = window.confirm('Энэ хуудаснаас гарахдаа баталгаажуулна уу. Өөрчилсөн өгөгдөл алдаж магадгүй.');
  //     if (answer) {
  //       next();
  //     } else {
  //       next(false);
  //     }
  //   }

  // }
};
</script>

<style>
.payment-grid {
  display: grid;
  gap: 20px;
  margin-bottom: 24px;
}

.payment-method {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 20px;
  border: 2px solid #e0e0e0;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.payment-method:hover {
  border-color: #18cdca;
  transform: translateY(-2px);
}

.payment-method.selected {
  border-color: #18cdca;
  background-color: rgba(24, 205, 202, 0.1);
}

.method-icon img {
  width: 100px;
  height: 100px;
  object-fit: contain;
}

@media (max-width: 768px) {
  .card {
    width: 100% !important;
  }
}
</style>
